import React from "react";
import Dots from "../Dots";
import "./Form.style.scss";

const Form = ({
  full_name,
  dob,
  household_health,
  zip_code,
  own_house,
  adult_in_household,
  children_in_house,
  industry_employed_in,
  annual_income,
  annual_expenses,
  net_worth,
  income_consistency,
  investment_amount,
  investment_period,
  max_loss,
  changeHandler,
}) => {
  const ten_thousand = 10000;
  const hundred_million = 100000000;
  const incomeConsistency = ["guaranteed", "will grow", "varies"];

  const industry_sector_impacting_household = [
    "financials",
    "industrials",
    "healthcare",
    "energy",
    "telecom",
    "government",
    "charity",
    "real estate",
    "retired",
  ];
  const household_health_options = [
    "ALL",
    "FAMILY",
    "HOUSEHOLD HEAD",
    "DEPENDENTS",
  ];

  return (
    <div className="riskQuestForm text-uppercase">
      <div className="riskQuestForm__heading clearfix text-center">
        Personal profile
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          FUll Name{" "}
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          DATE OF birth{" "}
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          household healthcare needs
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix  align-middle">
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="text"
            name="full_name"
            className="text-center"
            defaultValue={full_name}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="date"
            name="dob"
            // min={`${new Date().getFullYear() - 75}-1-1`}
            // max={`${new Date().getFullYear() - 18}-1-1`}
            defaultValue={dob}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div
          className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0"
          style={{ padding: "10px" }}
        >
          <Dots
            list={household_health_options}
            tooltip={[
              "All Healthy",
              "> 1 Dependent need healthcare",
              "Head of house hold needs healthcare",
              "All need regular Healthcare",
            ]}
            value={household_health}
            dotHandler={(e) => changeHandler(e)}
          />
          {/* <select
            value={household_health}
            name="household_health"
            className="text-center text-uppercase"
            onChange={(e) => changeHandler(e)}
          >
            {household_health_options.map((e, i) => (
              <option value={e} key={i}>
                {e}
              </option>
            ))}
          </select> */}
        </div>
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          adults in household{" "}
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">{`children in household(<18 YRS)`}</div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          Industry employed in{" "}
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="adult_in_household"
            defaultValue={adult_in_household}
            className="text-center"
            min={0}
            max={15}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="children_in_house"
            defaultValue={children_in_house}
            className="text-center"
            min={0}
            max={15}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <select
            value={industry_employed_in}
            name="industry_employed_in"
            className="text-center text-uppercase"
            onChange={(e) => changeHandler(e)}
          >
            {industry_sector_impacting_household.map((e, i) => (
              <option value={e} key={i}>
                {e}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          ZIP Code
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          own house ?{" "}
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="zip_code"
            className="text-center"
            defaultValue={zip_code}
            maxLength={5}
            pattern="\d{5}"
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs- 12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <select
            value={own_house}
            name="own_house"
            className="text-center"
            onChange={(e) => changeHandler(e)}
          >
            <option value={true}>Yes</option>
            <option value={false}>No</option>
          </select>
        </div>
      </div>
      <div className="riskQuestForm__heading text-center clearfix">
        Financial profile
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          annual income{" "}
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          annual expenses
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          net worth{" "}
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="annual_income"
            defaultValue={annual_income}
            className="text-center"
            min={ten_thousand}
            max={hundred_million}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="annual_expenses"
            defaultValue={annual_expenses}
            className="text-center"
            min={ten_thousand}
            max={hundred_million}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="net_worth"
            defaultValue={net_worth}
            className="text-center"
            min={ten_thousand}
            max={hundred_million}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          income consistency{" "}
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          investment amount
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          innvestment period{" "}
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <select
            value={income_consistency}
            name="income_consistency"
            className="text-center text-uppercase"
            onChange={(e) => changeHandler(e)}
          >
            {incomeConsistency.map((e, i) => (
              <option value={e} key={i}>
                {e}
              </option>
            ))}
          </select>
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="investment_amount"
            defaultValue={investment_amount}
            className="text-center"
            min={ten_thousand}
            max={hundred_million}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="investment_period"
            defaultValue={investment_period}
            className="text-center"
            min={1}
            max={30}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
      </div>
      <div className="riskQuestForm__labels clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0 text-center">
          max loss{" "}
        </div>
      </div>
      <div className="riskQuestForm__inputs clearfix">
        <div className="col-xs-12 col-sm-4 col-md-4 mb-2 mb-sm-0">
          <input
            type="number"
            name="max_loss"
            defaultValue={max_loss}
            className="text-center"
            min={1000}
            max={100000}
            onChange={(e) => changeHandler(e)}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Form/Form.jsx